module.exports = __webpack_public_path__ + "img/package-1.da71c4eb.png";